
import { Panel } from "primereact/panel";
import { TextField } from "../../../components/TextField";
import { useTranslation } from "react-i18next";
import { formatarCNPJ, formatarCPF } from "../../../utils";

 

 
export const LaranjaChavePix = ({laranjaChavePix}: {laranjaChavePix: any}) => {
  const { t } = useTranslation();
  const getValue = (value?: string): string => value || "Não informado";
 
  return (
    <div style={{ width: "98%" }}>
      <Panel header={t('laranjaChavePix')}>
        {laranjaChavePix.message ? (<p>{laranjaChavePix.message}</p>):(<div>
       
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Documento"
                value={getValue(laranjaChavePix?.DOCUMENTO.length === 11 ? formatarCPF(laranjaChavePix?.DOCUMENTO) : formatarCNPJ(laranjaChavePix?.DOCUMENTO))}
              />
              <TextField
                label="Tipo Chave"
                value={getValue(laranjaChavePix?.TIPO_CHAVE)}
              />
              <TextField
                label="Probabilidade Titularidade"
                value={getValue(laranjaChavePix?.PROB_TITULARIDADE)}
              />
              <TextField
                label="Risco Laranja"
                value={getValue(laranjaChavePix?.RISCO_LARANJA)}
              />
              
            </div>
            <div>
              <TextField
                label="Risco Fraude"
                value={getValue(laranjaChavePix?.RISCO_FRAUDE)}
              />
              <TextField
                label="Chave"
                value={getValue(laranjaChavePix?.CHAVE_PIX)}
              />
              <TextField
                label="Status Chave"
                value={getValue(laranjaChavePix?.STATUS_CHAVE)}
              />
            </div>
          </section>
      
         
        </div>)} 
      </Panel>
      
    </div>
  );
};